// @flow

import { type Receipt } from '../types';
import { type Amount } from '@tectonics/prs/money';

export function getAmountLocalTotal(receipt: Receipt): Amount {
  return receipt['amount_local_total'];
}
